<template>
    <div class="c_table_wrap">
        <table class="memberInfo_table">
            <colgroup>
                <col width="200px;">
                <col width="">
            </colgroup>
            <tr>
                <td class="c_t_title">언어선택</td>
                <td class="write_content_td">
                    <!--          <el-input v-model="language" type="number" @input="parentChange('language',language)"></el-input>-->
                    <el-select v-model="language" @change="parentChange('language',language)"
                               :disabled="checkData(boardData)">
                        <el-option :value="''" :label="'전체'"></el-option>
                        <el-option v-for="(data, value, index) in languageList" :key="`noticeLanguage${value}`"
                                   :label="data.c_lang_ko" :value="Number(data.c_idx)"></el-option>
                    </el-select>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">말머리 입력</td>
                <td class="write_content_td">
                    <el-input v-model="headText" type="text" @input="parentChange('headText',headText)"></el-input>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">
                    제목
                </td>
                <td class="write_content_td">
                    <div class="write_content_div">
                        <el-input type="text" v-model="title" maxlength="30"
                                  @input="parentChange('title', title)"></el-input>
                        <div class="input_error mt5">{{ validation.firstError('title') }}</div>
                    </div>
                </td>
            </tr>

            <tr>
                <td class="c_t_title">내용</td>
                <td class="write_content_td">
                    <div class="write_content_div">
<!--                        <el-input type="textarea" id="content" v-model="content" rows="10"
                                  @input="parentChange('content', content)"></el-input>-->
                        <quill-editor
                            ref="contentEditor"
                            class="h300"
                            v-model="content"
                            :options="editorOption"
                        />
                        <div class="input_error">{{ validation.firstError('content') }}</div>
                    </div>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import alertMixins from "@/mixins/alertMixins";
import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";
import boardValidator from "@/mixins/validators/boardValidator";
import quillEditorMixins from "@/mixins/quillEditorMixins";
import {appLanguage} from "@/service/languageService"

export default {
    name: "BoardWriteDefaultLayout",
    mixins: [alertMixins, boardValidator, quillEditorMixins],
    components: {},
    inject: {
        boardWriteSetData: {
            default: () => {
            }
        },
    },
    provide() {
        return {}
    },
    props: {
        boardData: {
            default: () => {
                return {}
            }
        }
    },
    data() {
        return {
            languageList: appLanguage,
        }
    },
    created() {
    },
    mounted() {
        if (this.hasData()) {
            this.initSetData();
        } else {
            this.wr_seq = this.seq;
            this.boardWriteSetData('wr_seq', this.seq);
            this.boardWriteSetData('seq', this.seq);
        }
        EventBus.$on('BoardWriteDefaultLayoutValidator', this.checkValidator);

    },
    beforeDestroy() {
        EventBus.$off('BoardWriteDefaultLayoutValidator')
    },
    destroyed() {
    },
    computed: {},
    methods: {
        initSetData() {
            this.seq = this.boardData.wr_seq;
            this.parentChange('wr_seq', this.seq);
            this.title = this.boardData.wr_subject;
            this.parentChange('title', this.title);
            this.headText = this.boardData.wr_headtext;
            this.parentChange('headText', this.headText);
            this.language = this.boardData.Language.c_idx;
            this.parentChange('language', this.language);
            this.content = this.boardData.wr_content
            this.content = util.htmlDecode(this.content);
            this.parentChange('content', this.content);
        },

        hasData() {
            return !util.isEmpty(this.boardData) && !util.isEmpty(this.boardData.wr_id);
        },

        checkValidator(dataArr) {
            this.$validate(dataArr)
        },

        parentChange(key, value) {
            if(key === 'content'){
                this.content = this.replaceN(value);
                value = this.content
            }
            this.boardWriteSetData(key, value)
        },
        checkData(data) {
            return !util.isEmpty(data);
        },
    },
    watch: {
        'content': {
            deep: true,
            handler: function (val, oldVal) {
                this.parentChange('content', this.content)
            },
        }
    },
}
</script>

<style scoped>

</style>
